module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_document":"New document"},"de":{"new_document":"Neues Dokument"}}')
  delete Component.options._Ctor
}
